import { FilterOptions } from '@/helpers/filter/models/FilterOptions';
import { FilterData } from '@/helpers/filter/models/FilterData';

import { SearchQueryFilterHandler } from '@/helpers/filter/handlers/SearchQueryFilterHandler';
import { TagFilterHandler } from '@/helpers/filter/handlers/TagFilterHandler';
import { OnlyMyLessonsFilterHandler } from '@/helpers/filter/handlers/OnlyMyLessonsFilterHandler';

import { EmptyElementsFilterHandler } from '@/helpers/filter/handlers/EmptyElementsFilterHandler';
import { PMSubPhaseFilterHandler } from '@/helpers/filter/handlers/PMSubPhaseFilterHandler';

import { PhaseFilterHandler } from '@/helpers/filter/handlers/PhaseFilterHandler';

export class FilterManager {
    private searchQueryFilterHandler = new SearchQueryFilterHandler();
    private tagFilterHandler = new TagFilterHandler();
    private onlyMyLessonsFilterHandler = new OnlyMyLessonsFilterHandler();

    private phaseFilterHandler = new PhaseFilterHandler();
    private pmSubPhaseFilterHandler = new PMSubPhaseFilterHandler();
    private emptyElementsFilterHandler = new EmptyElementsFilterHandler();

    constructor() {
        this.onlyMyLessonsFilterHandler
            .setNext(this.tagFilterHandler)
            .setNext(this.phaseFilterHandler)
            .setNext(this.pmSubPhaseFilterHandler)
            .setNext(this.emptyElementsFilterHandler)
            .setNext(this.searchQueryFilterHandler);
    }

    public filter(data: FilterData[], filterOptions: FilterOptions): FilterData[] {
        // console.log('FilterManager->filter');
        // console.log('FilterManager->data: ', data);
        // console.log('FilterManager->filterOptions: ', filterOptions);

        return this.onlyMyLessonsFilterHandler.handle(data, filterOptions);
    }
}
